import { IDataTableBloc } from "./DataTableBloc";
import { IDataTableRepository } from "./DataTableRepository";

type ColumnType = 'text' | 'markdown' | 'numeric' | 'date' | 'datetime' | 'datestring' | 'gallery' | 'image' | 'file' | 'feature' | 'object' | 'hashtags';


export interface Column {
    name?: string;
    field: string;
    type: ColumnType;
    has?: Column[];
    show?: boolean;
    edit?: boolean;
}

export interface AdminDataTableProps {
    collection: string;
    columns: Column[];
    repository?: IDataTableRepository;
}

export interface AdminDataTableBodyProps {
    cubit: IDataTableBloc;
    collection: string;
    columns: Column[];
}
export interface AddEditModalProps<T> {
    show: boolean;
    columns: Column[];
    collection: string;
    onClose: () => void;
    onSave: (data: T) => Promise<void> | void;
    onUpdate?: (data: T) => Promise<void> | void;
    onUploadFile?: (filename: string, blob: Blob) => Promise<string>;
    data?: T;
}

export interface RenderEditCellsProps<T> {
    columns: Column[];
    data: T;
    onUploadFile?: (filename: string, blob: Blob) => Promise<string>;
    onFieldValueChanged: () => void;
}

export interface ShowDetailsModalProps<T> {
    show: boolean;
    columns: Column[];
    collection: string;
    onClose: () => void;
    data: T;
}

export interface DeleteModalProps {
    show: boolean;
    onClose: () => void;
    onDelete: () => void;
}

export function rowDataObject<T>(row: T) {
    try {
        return (JSON.parse(JSON.stringify(row)));
    } catch (error) {
        console.log(error)
    }
}

export function rowData<T>(row: T, col: Column) {
    return (JSON.parse(JSON.stringify(row ?? {})))[col.field];
}

export function createEmptyObjectFromColumns(cols: Column[]): Object {
    const object = {};
    for (const col of cols) {
        if (col.type !== 'object') {
            (object as any)[col.field] = undefined;
        } else if (col.has !== undefined) {
            (object as any)[col.field] = createEmptyObjectFromColumns(col.has!)
        }
    }
    return object;
}